<template>
    <div id="user" />
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

import utils from '../../js/utils';

export default {
    props: ['url'],
    store: [
        'api',
        'user',
        'myTraits',
        'traitsIndex',
        'trackerData',
        'timeOfLast',
        'onboardingCompleted',
        'myValueTraits',
        'myEvents',
        'currentTab',
        'currentCourse',
        'unreadEvents',
        'coursesIndex',
        'topicsIndex',
        'unitsIndex',
        'fullDataIndex',
        'partners',
        'progress',
        'myTopics',
    ],
    data () {
        return {
            breakInit: false,
            firstPageLoad: true,
            gettingPartners: false,
        };
    },
    mounted: function () {
    },
    created: function () {
        this.$events.on('pulse-get', this.getPulse);
        this.$events.on('partners-get', (data) => {
            console.log('partners-get');
            let callback = data ? data.cb : null;
            this.getPartners(callback);
        });
        this.$events.on('user-get', (type, redirect) => {
            this.getInitialUser(type, redirect);
        });
        // this.$events.on('user-save', defined later as user is setup.
        this.setUpAuth();
        this.setUpAuthChangeHandler();
        document.addEventListener('online', () => {
            console.log('Online event resume');
            window.isOffline = false;
            this.refreshJwt(() => {
                this.$events.fire('user-get', 'resume', false);
            });
        });
        document.addEventListener(
            'resume',
            () => {
                setTimeout(() => {
                    console.log('Resume event jwt refresh');
                }, 10);
                this.refreshJwt();
            },
            false
        );
    },
    methods: {
        setUpAuthChangeHandler: function () {
            if (pgap && cordova.plugins.firebase && cordova.plugins.firebase.auth) {
                cordova.plugins.firebase.auth.onAuthStateChanged((userInfo) => {
                    if (userInfo) {
                        // user was signed in
                        cordova.plugins.firebase.auth.getIdToken().then((idToken) => {
                            Vue.http.headers.common.jwt = idToken;
                            Vue.http.headers.common.csrfToken = utils.getCookie('csrfToken');
                            localStore.setItem('jwt', idToken);
                            setTimeout(() => {
                                this.refreshJwt();
                            }, 50 * 60 * 1000);
                            this.$events.fire('jwt-set');
                            if (this.firstPageLoad) {
                                this.firstPageLoad = false;
                                if (!window.localStore.getItem('isRegister'))
                                    this.$events.fire('user-get', 'resume', true);
                            }
                        });
                    } else {
                        // user was signed out
                    }
                });
            }
            firebase.auth().onAuthStateChanged(user => {
                // console.log('AuthStateChanged', user);
                if (user) {
                    firebase
                        .auth()
                        .currentUser.getIdToken(true)
                        .then(idToken => {
                            Vue.http.headers.common.jwt = idToken;
                            Vue.http.headers.common.csrfToken = utils.getCookie('csrfToken');
                            localStore.setItem('jwt', idToken);
                            setTimeout(() => {
                                this.refreshJwt();
                            }, 50 * 60 * 1000);
                            this.$events.fire('jwt-set');
                            if (this.firstPageLoad) {
                                this.firstPageLoad = false;
                                if (!window.localStore.getItem('isRegister'))
                                    this.$events.fire('user-get', 'resume', true);
                            }
                        })
                        .catch(err => {
                            console.error('Could not connect 20200', err);
                            setTimeout(() => {
                                // Could be offline
                                if (!window.isOffline) {
                                    f7.dialog.confirm(
                                        'Retry authentication?',
                                        'Could not connect 20200',
                                        () => {
                                            this.setUpAuthChangeHandler();
                                        },
                                        () => {
                                            f7.dialog.confirm(
                                                'Are you sure?',
                                                'Log out',
                                                () => { },
                                                () => {
                                                    this.setUpAuthChangeHandler();
                                                }
                                            );
                                        }
                                    );
                                }
                            }, 2000);

                            setTimeout(() => {
                                this.fadeSplash();
                            }, 200);
                        });
                } else {
                    setTimeout(() => {
                        this.fadeSplash();
                    }, 200);
                }
            });
        },
        refreshJwt: function (cb) {
            if (!firebase.auth().currentUser) return setTimeout(this.refreshJwt, 10 * 1000);
            firebase
                .auth()
                .currentUser.getIdToken(true)
                .then(idToken => {
                    console.log('firebase refresh jwt');
                    Vue.http.headers.common.jwt = idToken;
                    localStore.setItem('jwt', idToken);
                    if (cb) cb();
                    setTimeout(() => {
                        this.refreshJwt();
                    }, 50 * 60 * 1000);
                })
                .catch(() => {
                    f7.dialog.confirm(
                        'Retry authentication?',
                        'Could not connect 20300',
                        () => {
                            window.location.reload();
                        });
                });
        },
        setUpAuth: function () {
            if (this.firstPageLoad) {
                try {
                    const config = location.hostname === 'staging.getcoral.app' ?
                        {
                            apiKey: "AIzaSyDsCmszkIaqYvQVtT8xf0tmZ7xtktaFXTg",
                            authDomain: "coral-staging-39468.firebaseapp.com",
                            databaseURL: "https://coral-staging-39468.firebaseio.com",
                            projectId: "coral-staging-39468",
                            storageBucket: "coral-staging-39468.appspot.com",
                            messagingSenderId: "54744284301",
                            appId: "1:54744284301:web:5d7a349651b802afed76c4",
                            measurementId: "G-Z83N6T45G4"

                        } : {
                            apiKey: "AIzaSyCnWMHLUbjZew3U9jHx7BisUEJNZa5D8nE",
                            authDomain: "coral-11.firebaseapp.com",
                            databaseURL: "https://coral-11.firebaseio.com",
                            projectId: "coral-11",
                            storageBucket: "coral-11.appspot.com",
                            messagingSenderId: "916077449389",
                            appId: "1:916077449389:web:5c42ec1627cfb632",
                            measurementId: "G-M30RMSJFWG"
                        };
                    firebase.initializeApp(config);
                } catch (e) {
                    console.log('Firebase already setup (if using hmr)');
                }
            }
        },
        getInitialUser: function (type, redirect, callback) {
            f7.preloader.show();
            this.$http.get(this.api + '/users/me').then(
                response => {
                    this.user = response.body;
                    // if (this.user.id < 6000 && !this.user.isSubscribed) localStore.setItem('COUPON', 'BETA');
                    if (localStore.getItem('COUPON')) this.handleCoupon();
                    if (localStore.getItem('INVITE')) this.getPartners();
                    if (callback) callback();
                    this.$events.on('user-save', cb => {
                        if (typeof cb !== 'undefined') f7.preloader.show();
                        setTimeout(() => {
                            if (localStore.getItem('COUPON')) this.handleCoupon();
                            if (localStore.getItem('INVITE')) this.getPartners();
                        }, 2000);
                        this.$http.put(`${this.api}/users/${this.user.id}`, this.user).then(
                            response => {
                                this.user = response.body;
                                if (typeof cb !== 'undefined') {
                                    f7.preloader.hide();
                                    cb();
                                }
                            },
                            response => {
                                if (typeof cb !== 'undefined') {
                                    f7.preloader.hide();
                                    cb(response.body.message);
                                    f7.dialog.alert(response.body.message || 'Something went wrong');
                                }
                                console.error('Problem saving user', response.body);
                            }
                        );
                    });
                    if (this.user.isAdmin) {
                        // disable tracking
                        window['ga-disable-374193653'] = true;
                        if (pgap && cordova.plugins.firebase && cordova.plugins.firebase.analytics) {
                            cordova.plugins.firebase.analytics.setEnabled(false);
                        }
                    }
                    this.getUserTraits();
                    this.getUserActivity(() => {
                        this.getPulse();
                    });
                    this.getUserProgress();
                    this.getUserTopics();
                    setTimeout(() => {
                        f7.preloader.hide();
                    }, 120);
                    if (type) {
                        this.$events.emit('trackUserLogin', type);
                    }
                    if (redirect) {
                        if (type === 'register') {
                            setTimeout(() => {
                                f7.views['main'].router.navigate('/onboarding', {
                                    clearPreviousHistory: true,
                                    animate: false
                                });
                                setTimeout(() => {
                                    this.fadeSplash();
                                }, 200);
                            }, 400);
                            return this.fadeSplash();
                        }
                        this.getPartners();
                        if (this.url && this.url === 'web') this.url = false;
                        if (this.url) this.url = this.url.replace('//', '');
                        if (pgap) this.url = localStore.getItem('deeplink') || false;
                        console.log('[Init]', this.url);
                        if (this.url && ['/start', '/login', '/register', '/onboarding', '/onboarding2', '/onboarding3', '/onboarding4'].indexOf(this.url) === -1) {
                            setTimeout(() => {
                                console.log('[Redirect]', this.url);
                                if (this.url && this.url.indexOf('/explore') > -1) {
                                    this.currentTab = 'explore';
                                } else if (this.url && this.url.indexOf('/profile') > -1) {
                                    this.currentTab = 'profile';
                                }
                                if ((this.url.indexOf('/units/') > -1 || this.url.indexOf('/comments/') > -1)) {
                                    // f7.views['main'].router.navigate('/home', { clearPreviousHistory: true, animate: false });
                                } else {
                                    f7.views['main'].router.navigate(this.url ? this.url : '/start', { clearPreviousHistory: true, animate: false });
                                }
                                localStore.removeItem('deeplink');
                                if (!this.breakInit) {
                                    this.breakInit = true;
                                    f7.params.panel.leftBreakpoint = 768;
                                    this.initBreakpoints();
                                }
                                setTimeout(() => {
                                    this.fadeSplash();
                                }, 200);
                            }, 1000);
                        } else {
                            if (this.user.day === 0 && this.onboardingCompleted < 1) {
                                f7.views['main'].router.navigate('/home', {
                                    // onboarding
                                    clearPreviousHistory: true,
                                    animate: false
                                });
                                if (!this.breakInit) {
                                    this.breakInit = true;
                                    f7.params.panel.leftBreakpoint = 768;
                                    this.initBreakpoints();
                                }
                            } else {
                                f7.views['main'].router.navigate('/home', {
                                    clearPreviousHistory: true,
                                    animate: false
                                });
                                if (!this.breakInit) {
                                    this.breakInit = true;
                                    f7.params.panel.leftBreakpoint = 768;
                                    this.initBreakpoints();
                                }
                            }
                            setTimeout(() => {
                                // failsafe
                                if (!pgap) {
                                    f7.views['main'].router.navigate('/home');
                                }
                                this.fadeSplash();
                            }, 400);
                        }
                    } else {
                        this.getPartners();
                    }
                },
                response => {
                    f7.preloader.hide();
                    console.error(response);
                    f7.dialog.confirm(
                        `Authentication error. Could not retrieve your account details.<br>
                        ${response.body.message ? response.body.message : ''}`,
                        'Retry',
                        () => {
                            this.getInitialUser(type, true);
                        },
                        () => {
                            f7.dialog.confirm(
                                'Are you sure?',
                                'Log out',
                                () => {
                                    this.$events.fire('userLogout');
                                    if (pgap && cordova.plugins.firebase && cordova.plugins.firebase.auth) {
                                        cordova.plugins.firebase.auth.signOut();
                                    }
                                    firebase
                                        .auth()
                                        .signOut()
                                        .then(() => {
                                            // authstate change listener is app.vue
                                            setTimeout(() => {
                                                // give time for events to fire (eg: trackers)
                                                localStore.removeItem('uuid');
                                                localStore.removeItem('jwt');
                                                localStore.removeItem('adminUnlockAll');
                                                localStore.removeItem('freeFromPartner')
                                                if (pgap) {
                                                    window.location.reload();
                                                } else {
                                                    window.location.href = '/';
                                                }
                                            }, 400);
                                        });
                                },
                                () => {
                                    this.getInitialUser(type, true);
                                }
                            );
                        }
                    );
                }
            );
        },
        getUserTraits: function () {
            this.$http.get(`${this.api}/users/${this.user.id}/traits`).then(
                response => {
                    Vue.set(this, 'myTraits', response.body.traits || []);
                    Vue.set(this, 'myValueTraits', response.body.valueTraits || []);
                    window.userTraitsFetched = true;
                    this.$events.fire('userUpdateTraits');
                    this.$events.fire('get-home');
                    this.$events.fire('get-explore');
                },
                (response) => {
                    utils.failedRequest('full', response, true);
                }
            );
        },
        getUserActivity: function (cb) {
            this.$http.get(`${this.api}/events`).then(
                response => {
                    this.myEvents = response.body;
                    this.unreadEvents = 0;
                    for (let i = 0; i < this.myEvents.length; i++) {
                        const event = this.myEvents[i];
                        if (!event.read) this.unreadEvents++;
                    }
                    if (typeof cb !== 'undefined') cb();
                },
                () => {
                    console.error('Could not fetch events');
                    if (typeof cb !== 'undefined') cb();
                }
            );
        },
        getUserTopics: function () {
            this.$http.get(`${this.api}/users/${this.user.id}/topics`).then(
                response => {
                    let topics = response.body;
                    for (let i = 0; i < topics.length; i++) {
                        topics[i] = parseFloat(topics[i]);
                    }
                    Vue.set(this, 'myTopics', topics);
                },
                response => {
                    f7.preloader.hide();
                    f7.dialog.alert(response.body.message || 'Unknown error');
                }
            );
        },
        getUserProgress: function () {
            console.log('[Progress] get');
            this.$http.get(`${this.api}/progress`).then(
                response => {
                    this.progress = response.body || [];
                    console.log('[Progress]', 'ok', this.progress.length)
                    // rebuilds the localdb including progress
                    this.$events.fire('user-progress-fetched');
                },
                (response) => {
                    utils.failedRequest('full', response, true);
                }
            );
            this.$events.on('user-progress', (data, cb) => {
                if (!(data && data.item)) {
                    return;
                }

                data.item = JSON.parse(JSON.stringify(data.item));
                if (data.type === 'topic') {
                    delete data.item.courses;
                }
                if (data.type === 'course') {
                    delete data.item.units;
                }
                if (data.type === 'unit') {
                    delete data.item.slides;
                }
                this.$http.post(`${this.api}/progress`, data).then(
                    () => {
                        if (typeof cb !== 'undefined') cb(data);
                    },
                    (response) => {
                        if (typeof cb !== 'undefined') cb();
                        utils.failedRequest('full', response, true);
                    }
                );

                // update local progress
                // for (let i = 0; i < this.progress.length; i++) {
                //     const e = this.progress[i];
                //     if (e.type === data.type &&
                //         e.courseId === data.courseId &&
                //         e.unitId === data.unitId &&
                //         e.topicId === data.topicId) {
                //         this.progress[i] = data;
                //     } else {
                //         this.progress.push(data);
                //     }
                // }
                // end update local progress
                if (data.completed) {
                    this.$events.fire(
                        'trackEvent',
                        `${data.type}_completed`,
                        'progress',
                        data.item.isVersionOf || data.item.id,
                        data.item.name,
                        data.item
                    );
                    if (data.type === 'unit') {
                        const unit = this.unitsIndex[data.item.isVersionOf || data.item.id];
                        if (unit) {
                            unit.completed = true;
                            Vue.set(this.unitsIndex[unit.id], 'completed', true);


                            if (this.user.unitsCompleted === 6 || unit.id === 197) {
                                this.$events.fire('ask-for-rating');
                            }
                            // TODO move to backend
                            this.user.unitsCompleted++;
                            this.$events.fire('user-save');
                            // complete a course and or topic if all eligible items are done
                            if (this.coursesIndex[unit.courseId] &&
                                !this.coursesIndex[unit.courseId].completed &&
                                this.currentCourse &&
                                this.currentCourse.id === unit.courseId) {
                                let eligible = 0;
                                let completed = 0;
                                for (let i = 0; i < this.coursesIndex[unit.courseId].units.length; i++) {
                                    const u = this.coursesIndex[unit.courseId].units[i];
                                    if (utils.checkTraits(this.myTraits, u)) {
                                        eligible++;
                                        if (this.unitsIndex[u.id].completed) completed++;
                                    }
                                }
                                // lastEligibleUnitInCourse
                                if (completed >= eligible && unit.courseId) {
                                    // this.coursesIndex[unit.courseId].completed = true;
                                    Vue.set(this.coursesIndex[unit.courseId], 'completed', true);
                                    // Vue.set(this.coursesIndex, unit.courseId, this.coursesIndex[unit.courseId]);
                                    this.$events.fire('user-progress', {
                                        itemId: 0,
                                        courseId: unit.courseId,
                                        topicId: this.coursesIndex[unit.courseId].topicId ? this.coursesIndex[unit.courseId].topicId : 0,
                                        type: 'course',
                                        progress: 100,
                                        completed: true,
                                        item: this.coursesIndex[unit.courseId]
                                    });
                                }
                            }
                            if (unit.courseId && this.coursesIndex[unit.courseId] &&
                                this.topicsIndex[this.coursesIndex[unit.courseId].topicId] &&
                                !this.topicsIndex[this.coursesIndex[unit.courseId].topicId].completed) {
                                let completed = 0;
                                for (let i = 0; i < this.fullDataIndex[this.coursesIndex[unit.courseId].topicId].courses.length; i++) {
                                    const c = this.fullDataIndex[this.coursesIndex[unit.courseId].topicId].courses[i];
                                    if (c.completed) completed++;
                                }
                                if (completed >= this.fullDataIndex[this.coursesIndex[unit.courseId].topicId].courses.length) {
                                    // this.topicsIndex[unit.topicId].completed = true;
                                    Vue.set(this.topicsIndex[this.coursesIndex[unit.courseId].topicId], 'completed', true);
                                    // Vue.set(this.topicsIndex, this.coursesIndex[unit.courseId].topicId, this.topicsIndex[unit.topicId]);
                                    this.$events.fire('user-progress', {
                                        itemId: 0,
                                        courseId: 0,
                                        topicId: this.coursesIndex[unit.courseId] ? this.coursesIndex[unit.courseId].topicId : 0,
                                        type: 'topic',
                                        progress: 100,
                                        completed: true,
                                        item: this.topicsIndex[unit.topicId]
                                    });
                                }
                            }
                        }
                    }
                } else if (!data.completed && data.progress === 0) {
                    this.$events.fire(
                        'trackEvent',
                        `${data.type}_started`,
                        'progress',
                        data.item.isVersionOf || data.item.id,
                        data.item.name,
                        data.item
                    );
                    // starting a course and or topic
                    if (data.type === 'unit') {
                        const unit = this.unitsIndex[data.item.isVersionOf || data.item.id];
                        if (!unit) {
                            console.log('odd?? no unit ', data.item.isVersionOf || data.item.id);
                            this.unitsIndex[data.item.isVersionOf || data.item.id] = data.item;
                        } else {
                            unit.started = true;
                            // set to 10 so visually
                            Vue.set(unit, 'progress', 10);
                            if (this.coursesIndex[unit.courseId] && !this.coursesIndex[unit.courseId].started) {
                                // this.coursesIndex[unit.courseId].started = true;
                                Vue.set(this.coursesIndex[unit.courseId], 'started', true);
                                // Vue.set(this.coursesIndex, unit.courseId, this.coursesIndex[unit.courseId]);
                                this.$events.fire('user-progress', {
                                    itemId: 0,
                                    courseId: unit.courseId,
                                    topicId: this.coursesIndex[unit.courseId].topicId,
                                    type: 'course',
                                    progress: 0,
                                    completed: false,
                                    item: this.coursesIndex[unit.courseId]
                                });
                            }
                            if (unit.courseId && this.coursesIndex[unit.courseId] && ['learn', 'goal'].indexOf(this.topicsIndex[this.coursesIndex[unit.courseId].topicId].type) > -1) {
                                this.user.currentCourseId = unit.courseId;
                                this.$events.fire('user-save');
                            }
                            // could not be a topic but a section init?
                            if (this.topicsIndex[this.coursesIndex[unit.courseId].topicId] && !this.topicsIndex[this.coursesIndex[unit.courseId].topicId].started) {
                                // this.topicsIndex[unit.topicId].started = true;
                                Vue.set(this.topicsIndex[this.coursesIndex[unit.courseId].topicId], 'started', true);
                                // Vue.set(this.topicsIndex, this.coursesIndex[unit.courseId].topicId, this.topicsIndex[unit.topicId]);
                                this.$events.fire('user-progress', {
                                    itemId: 0,
                                    courseId: 0,
                                    topicId: this.coursesIndex[unit.courseId].topicId,
                                    type: 'topic',
                                    progress: 0,
                                    completed: false,
                                    item: this.topicsIndex[this.coursesIndex[unit.courseId].topicId]
                                });
                            }
                        }
                    }
                } else {
                    console.log(`unit-progress-${data.progress}`);
                    if (data.type === 'unit' && this.unitsIndex[data.item.isVersionOf || data.item.id]) {
                        Vue.set(this.unitsIndex[data.item.isVersionOf || data.item.id], 'progress', data.progress);
                    }
                }
            });
        },
        getPartners: function (cb) {
            console.log('[Get partners]', this.gettingPartners);
            if (!cb) cb = () => { };
            if (this.gettingPartners) return;
            this.gettingPartners = true;
            this.$http.get(`${this.api}/partners`).then(
                response => {
                    this.partners = response.body || [];
                    console.log('[Get partners] result:', this.partners.length);
                    this.gettingPartners = false;
                    if (this.partners.length === 0) return cb();
                    let found = 0;
                    for (let i = 0; i < this.partners.length; i++) {
                        const p = this.partners[i];
                        if (p.partnerId === 0 && !p.accepted && p.userId !== this.user.id) {
                            found = 1;
                            f7.dialog.confirm(`${p.name} wants to hookup. Do you want to accept their request to link your accounts?`, () => {
                                this.$http
                                    .post(`${this.api}/partners/accept`, {
                                        invite: p.id,
                                    })
                                    .then(
                                        response => {
                                            console.log('invite OK', response.body);
                                            f7.dialog.alert('Your partner has been added to your journey!');
                                            this.user.hasPartner = true;

                                            if (response.body.freeFromPartner) {
                                                localStore.setItem('freeFromPartner', '/freeViaPartner');
                                                cb();
                                                setTimeout(() => {
                                                    this.$events.fire('user-get');
                                                    setTimeout(() => {
                                                        f7.views['main'].router.navigate('/freeViaPartner');
                                                    }, 1000);
                                                }, 200);
                                            }
                                        },
                                        (data) => {
                                            cb();
                                            console.error('invite Error', data.body);
                                            f7.dialog.alert(data.body && data.body.message ? data.body.message : 'Something went wrong accepting your partner invitation.')
                                        }
                                    );
                            }, cb);
                        }
                    }
                    if (!found) cb();
                },
                response => {
                    this.gettingPartners = false;
                    console.error('could not fetch partners', response.body)
                }
            );
        },
        handleCoupon: function () {
            const coupon = localStore.getItem('COUPON');
            localStore.removeItem('COUPON');
            if (coupon && !this.user.isSubscribed) {
                this.$http
                    .post(`${this.api}/subscriptions/coupon`, {
                        code: coupon,
                    })
                    .then(
                        response => {
                            console.log('coupon OK', coupon, response.body);
                            this.$events.fire('user-save', () => {
                                if (coupon === 'BETA' && !this.user.isAdmin) {
                                    f7.dialog.alert('Your code has been applied! You have 6-months of Coral for free!');
                                } else {
                                    f7.dialog.alert(`Your code has been applied! You have a free ${response.body.months}-month(s) subscription to Coral!`);
                                }
                            });
                        },
                        (data) => {
                            console.error('coupon Error', coupon, data.body);
                            f7.dialog.alert(data.body && data.body.message ? data.body.message : 'Something went wrong trying to apply your PRESS CODE.')
                        }
                    );
            }

        },
        getPulse: function (cb) {
            if (!this.user.id) return;
            this.$http.get(`${this.api}/users/timeForTracker`).then(
                response => {
                    this.$set(this.trackerData, 'timeForTracker', response.body.timeForTracker);
                    this.$set(this.trackerData, 'countSinceLast', response.body.countSinceLast);
                    this.$set(this.trackerData, 'lastOne', response.body.lastOne);
                    if (this.trackerData.lastOne) {
                        this.timeOfLast = this.trackerData.lastOne.createdAt;
                    }
                    if (typeof cb !== 'undefined') cb();
                },
                () => {
                    console.error('Could not fetch time for tracker');
                    if (typeof cb !== 'undefined') cb();
                }
            );
        },
        fadeSplash: function () {
            let splash = document.getElementById('splash');
            splash.className = 'fadeout afterFadeOut';
        },
        initBreakpoints: function () {
            let panel = f7.panel.get('.panel-left');
            panel.params.visibleBreakpoint = 768;
            panel.enableVisibleBreakpoint();
        },
    }
};
</script>
<style lang="less" scoped>
#user {
    display: hidden;
}
</style>
